import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Sidebar } from 'primeng/primeng';

// import { StrtInitiative } from '../../../../services/StrtInitiative';
import { StrtInitiative } from '../../../../../shared/models/plan/StrtInitiative';
import { StepComponent } from '../../../step.component';
// import { StrtOutcome } from '../../../../services/StrtOutcome';
import { StrtOutcome } from '../../../../../shared/models/plan/StrtOutcome';


@Component({
  selector: 'app-outcome',
  templateUrl: './outcome.component.html',
  styleUrls: ['./outcome.component.scss']
})
export class OutcomeComponent implements OnInit, OnChanges {
  readonly MAX_OUTCOME_LENGTH = 100;
  readonly MAX_OUTCOMES = 10;

  @Output() create = new EventEmitter<StrtOutcome[]>();
  @Output() createError = new EventEmitter<Error>();
  @Output() edit = new EventEmitter<StrtOutcome>();
  @Output() editError = new EventEmitter<Error>();
  @Output() cancel = new EventEmitter<void>();

  private _outcomeForm: FormGroup;
  private _isActive = false;
  private _isEdit = false;
  private pristineInitiative: StrtInitiative;
  private pristineOutcome: StrtOutcome;

  outcomes: StrtOutcome[] = [];

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    StepComponent.logNgOnChanges(changes);
  }

  get headerContent() {
    return this.isEdit ? 'Edit Intended Outcome' : 'Add Intended Outcome';
  }

  get initiativeDescription() {
    return this.pristineInitiative ? this.pristineInitiative.description : '';
  }

  get outcomeForm() {
    return this._outcomeForm;
  }

  get outcome() {
    return this.outcomeForm.get('outcome');
  }

  get isEdit() {
    return this._isEdit;
  }

  get isAddDisabled(): boolean {
    return this.outcome.value.length === 0
      || (this.pristineInitiative.outcomes.length + this.outcomes.length) >= this.MAX_OUTCOMES;
  }

  get isSubmitDisabled() {
    if (this.isEdit) {
      return !(this.outcomeForm.status === 'VALID' &&
        !this.outcomeForm.pristine &&
        this.outcomeForm.dirty);
    } else {
      return this.outcomes.length === 0;
    }
  }

  get outcomeRemainingCharacters() {
    return this.MAX_OUTCOME_LENGTH - this.outcome.value.length;
  }

  get isActive() {
    return this._isActive;
  }

  set isActive(isActive) {
    this._isActive = isActive;
  }

  createOutcome(initiative: StrtInitiative) {
    this._isActive = true;
    this._isEdit = false;
    this.outcome.setValidators([Validators.maxLength(this.MAX_OUTCOME_LENGTH)]);
    this.resetForm();
    this.pristineInitiative = initiative;
  }

  editOutcome(initiative: StrtInitiative, outcome: StrtOutcome) {
    this._isActive = true;
    this._isEdit = true;
    this.outcome.setValidators([Validators.maxLength(this.MAX_OUTCOME_LENGTH), Validators.required]);
    this.resetForm();
    this.pristineInitiative = initiative;
    this.pristineOutcome = outcome;
    this.outcomeForm.patchValue({outcome: this.pristineOutcome.outcome});
  }

  onShowSidebar(sidebar: Sidebar) {
    sidebar.maskClickListener();
  }

  onHideSidebar() {
    this._isActive = false;
    this._isEdit = false;
    this.resetForm();
  }

  onSubmit() {
    const outcomes = this.formToOutcome();
    if (this.isEdit) {
      this.edit.emit(outcomes as StrtOutcome);
    } else {
      this.create.emit(outcomes as StrtOutcome[]);
    }
  }

  onAddOutcomeClick() {
    const outcome = {initiativeId: this.pristineInitiative.initiativeId, outcome: this.outcome.value};
    this.outcomes = [...this.outcomes, outcome];
    this.outcomeForm.patchValue({outcome: ''});
  }

  onDeleteOutcomeClick(outcome: StrtOutcome) {
    this.outcomes = this.outcomes.filter(it => it !== outcome);
  }

  private createForm() {
    this._outcomeForm = this.formBuilder.group({
      outcome: ['', [Validators.maxLength(this.MAX_OUTCOME_LENGTH)]]
    });
  }

  private resetForm() {
    this.outcomeForm.reset({outcome: ''});
    this.outcomes = [];
    this.pristineInitiative = undefined;
    this.pristineOutcome = undefined;
  }

  private formToOutcome(): StrtOutcome|StrtOutcome[] {
    if (this.isEdit) {
      const outcome = {outcome: this.outcome.value};
      return Object.assign({}, this.pristineOutcome, outcome);
    } else {
      return this.outcomes;
    }
  }
}
